(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("katex"), require("@wangeditor-kai/editor"));
	else if(typeof define === 'function' && define.amd)
		define(["katex", "@wangeditor-kai/editor"], factory);
	else if(typeof exports === 'object')
		exports["WangEditorPluginFormula"] = factory(require("katex"), require("@wangeditor-kai/editor"));
	else
		root["WangEditorPluginFormula"] = factory(root["katex"], root["wangEditor"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__757__, __WEBPACK_EXTERNAL_MODULE__44__) => {
return 